export const AITags = {
    'SOPHIE': 'sophie',
    'TALLER': 'teller',
    'RENEE': 'renee',
    'RAINA': 'raina',
}